import React from "react";
import PropTypes from "prop-types";

const ConfidentialIcon = (props) => {
  const { width = "86", height = "86" } = props;

  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 86 86"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M72.7561 42.9999C72.7561 59.4337 59.4339 72.7559 43.0001 72.7559C26.5664 72.7559 13.2441 59.4337 13.2441 42.9999C13.2441 26.5661 26.5664 13.2439 43.0001 13.2439C59.4339 13.2439 72.7561 26.5661 72.7561 42.9999ZM19.1939 42.9999C19.1939 56.1477 29.8523 66.8062 43.0001 66.8062C56.148 66.8062 66.8064 56.1477 66.8064 42.9999C66.8064 29.8521 56.148 19.1936 43.0001 19.1936C29.8523 19.1936 19.1939 29.8521 19.1939 42.9999Z"
        fill="#FE8A00"
      />
    </svg>
  );
};

ConfidentialIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ConfidentialIcon;
